import { SYSTEM_LOADING_GETTER_IS_LOADING } from '@/store/modules/system/loading/systemLoading.constant'

export default {
  [SYSTEM_LOADING_GETTER_IS_LOADING] (state) {
    return state.isLoading
  }
}
